import { FunctionComponent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera } from '@fortawesome/pro-light-svg-icons';
import { Product } from '@spike/product-model';
import { Img } from 'react-image';
import isEmpty from 'lodash/isEmpty';
import Status from '../Status';
import styles from './StockSidebar.module.scss';

interface ProductHeaderProps {
    product: Product;
    trackingLabel: string;
}

export const getProductName = (product: Product): string => {
    if (isEmpty(product.businessProduct?.name)) {
        return product.name || '';
    }
    return product.businessProduct?.name || '';
};

export const formatMetric = (value: string | number | null | undefined): string | number => {
    if (value === undefined || value === null || value === '') {
        return '-';
    }

    return value;
};

export const ProductHeader: FunctionComponent<ProductHeaderProps> = ({ product, trackingLabel }) => {
    const inventory = product.businessProduct?.inventory;
    const imageUrl = product.businessProduct?.imageUrl || product.imageUrl;

    return (
        <div className={styles.productRow}>
            {imageUrl ? (
                <Img
                    src={imageUrl}
                    className={styles.imageBox}
                />
            ) : (
                <div className={styles.uploadBox}>
                    <FontAwesomeIcon
                        icon={faCamera}
                        className={styles.uploadIcon}
                    />
                </div>
            )}
            <div className={styles.productInfo}>
                <div className={styles.productIdentity}>
                    <span className={styles.productName}>{getProductName(product)}</span>
                    <span className={styles.trackingLabel}>{trackingLabel}</span>
                </div>
                {inventory?.status ? (
                    <Status status={inventory.status} />
                ) : (
                    <span className={styles.unlimitedChip}>Unlimited</span>
                )}
            </div>
        </div>
    );
};

export default ProductHeader;
